import { useLingui } from '@lingui/react/macro';
import { ArrowUpDown } from 'lucide-react';
import { NotificationType } from 'modules/core/domain/interfaces/supabase/notifications/types';
import { sortOptions, typeOptions } from 'modules/notifications/domain/const';
import { NotificationFilters } from 'modules/notifications/domain/interface/notification';
import React, { useMemo } from 'react';
import UDCard from 'ud-ui/components/card';
import UDFilterChip, { UDFilterChipGroup } from 'ud-ui/components/filter-chip';

interface Props {
  filters: NotificationFilters;
  onChange: (filters: NotificationFilters) => void;
  className?: string;
}

/** Фильтры списка: тип и сортировка — наборы чипов на своей плашке, выбранный чип тёмный. */
const NotificationsFilters: React.FC<Props> = ({ filters, onChange, className }) => {
  const { t } = useLingui();
  const translatedTypeOptions = useMemo(() => typeOptions.map((o) => ({ value: o.value, label: t(o.label) })), [t]);
  const translatedSortOptions = useMemo(() => sortOptions.map((o) => ({ value: o.value, label: t(o.label) })), [t]);
  const activeType = filters.type || 'all';
  const activeSort = filters.sort || 'desc';

  return (
    <UDCard padding="sm" className={`flex flex-col gap-3 ${className || ''}`}>
      <UDFilterChipGroup label={t`Тип уведомления`}>
        {translatedTypeOptions.map((option) => (
          <UDFilterChip
            key={option.value}
            selected={activeType === option.value}
            onClick={() => onChange({ ...filters, type: option.value as NotificationType | 'all' })}
          >
            {option.label}
          </UDFilterChip>
        ))}
      </UDFilterChipGroup>
      <UDFilterChipGroup label={t`Сортировка`} isLabelVisible icon={<ArrowUpDown size={16} aria-hidden />}>
        {translatedSortOptions.map((option) => (
          <UDFilterChip
            key={option.value}
            selected={activeSort === option.value}
            onClick={() => onChange({ ...filters, sort: option.value as 'desc' | 'asc' })}
          >
            {option.label}
          </UDFilterChip>
        ))}
      </UDFilterChipGroup>
    </UDCard>
  );
};

export default NotificationsFilters;
